const sizes = {
    bigBoxHeight:   80,
    bigBoxWidth:    180,
    bigBoxGap:      15,
    smallBoxHeight: 70,
    smallBoxWidth:  120,
    smallBoxGap:    10,
}

export default sizes;